import { render, staticRenderFns } from "./permissoes.vue?vue&type=template&id=797e4a60"
import script from "./permissoes.vue?vue&type=script&lang=js"
export * from "./permissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports